module.exports = __webpack_public_path__ + "media/images/down-029efa69d9991ad77b02015e4cabc80b.png";